import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { env } from "resume-builder-v2-common";

var callApi = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
    var method,
        payload,
        url,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            method = _args.length > 1 && _args[1] !== undefined ? _args[1] : "get";
            payload = _args.length > 2 ? _args[2] : undefined;
            url = "".concat(env.api, "/v1/").concat(path);
            _context.next = 5;
            return fetch(url, _objectSpread(_objectSpread({
              method: method.toUpperCase()
            }, payload && {
              body: JSON.stringify(payload)
            }), {}, {
              credentials: "include",
              mode: "cors",
              headers: [["Content-Type", "application/json"]]
            })).then(function (response) {
              return response.json();
            });

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function callApi(_x) {
    return _ref.apply(this, arguments);
  };
}();

export var BUG_REPORT_API = {
  Report: function () {
    var _Report = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(bugReport) {
      var result;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return callApi("bug-report", "post", bugReport);

            case 2:
              result = _context2.sent;
              return _context2.abrupt("return", result);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function Report(_x2) {
      return _Report.apply(this, arguments);
    }

    return Report;
  }()
};
export var RESUME_API = {
  Delete: function () {
    var _Delete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resumeId) {
      var result;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return callApi("resume/".concat(resumeId), "delete");

            case 2:
              result = _context3.sent;
              return _context3.abrupt("return", result);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function Delete(_x3) {
      return _Delete.apply(this, arguments);
    }

    return Delete;
  }(),
  Save: function () {
    var _Save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resumeId, payload) {
      var isNew, path, method, result;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              isNew = resumeId === "__NEW__";
              path = isNew ? "resume" : "resume/".concat(resumeId);
              method = isNew ? "put" : "patch";
              _context4.next = 5;
              return callApi(path, method, payload);

            case 5:
              result = _context4.sent;
              return _context4.abrupt("return", result);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function Save(_x4, _x5) {
      return _Save.apply(this, arguments);
    }

    return Save;
  }(),
  UpdateEntry: function () {
    var _UpdateEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resumeId, payload) {
      var result;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return callApi("resume/entry/".concat(resumeId), "patch", payload);

            case 2:
              result = _context5.sent;
              return _context5.abrupt("return", result);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function UpdateEntry(_x6, _x7) {
      return _UpdateEntry.apply(this, arguments);
    }

    return UpdateEntry;
  }()
};